// extracted by mini-css-extract-plugin
export default {"container":"ImageGenerator_container__hUTpx","content":"ImageGenerator_content__7VTJU","text":"ImageGenerator_text__i997h","downloadButton":"ImageGenerator_downloadButton__tRyDY"};